import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Games
export const createGame = (payload) => api.post("/games", payload).then((r) => r.data);
export const getGame = (id) => api.get(`/games/${id}`).then((r) => r.data);
export const getGameAsHost = (id, token) => api.get(`/games/${id}/host`, { params: { token } }).then((r) => r.data);
export const getGameByCode = (code) => api.get(`/games/by-code/${code}`).then((r) => r.data);
export const updateGame = (id, payload) => api.patch(`/games/${id}`, payload).then((r) => r.data);

// Tests
export const addTest = (gameId, payload) => api.post(`/games/${gameId}/tests`, payload).then((r) => r.data);
export const updateTest = (gameId, testId, payload) => api.patch(`/games/${gameId}/tests/${testId}`, payload).then((r) => r.data);
export const deleteTest = (gameId, testId) => api.delete(`/games/${gameId}/tests/${testId}`).then((r) => r.data);

// Teams
export const joinTeam = (payload) => api.post("/teams", payload).then((r) => r.data);
export const getTeam = (id) => api.get(`/teams/${id}`).then((r) => r.data);
export const listTeams = (gameId) => api.get(`/games/${gameId}/teams`).then((r) => r.data);
export const submitDiagnosis = (teamId, diagnosis) => api.post(`/teams/${teamId}/diagnosis`, { diagnosis }).then((r) => r.data);
export const gradeTeam = (teamId, grade) => api.patch(`/teams/${teamId}/grade`, { grade }).then((r) => r.data);

// Purchases
export const buyTest = (teamId, testId) => api.post(`/teams/${teamId}/purchases`, { test_id: testId }).then((r) => r.data);
export const listTeamPurchases = (teamId) => api.get(`/teams/${teamId}/purchases`).then((r) => r.data);
export const listGamePurchases = (gameId) => api.get(`/games/${gameId}/purchases`).then((r) => r.data);
export const revealResult = (purchaseId, result) => api.patch(`/purchases/${purchaseId}`, { result }).then((r) => r.data);

export const fmtMoney = (n) => `$${Number(n).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;
